<template>
  <div>
    <span>{{ attributeData.displayName }}</span>
    <v-text-field
      type="number"
      outlined
      :disabled="isLoading"
      :value="value"
      :error-messages="errorMessage"
      @change="$emit('input', Number($event))"
    />
  </div>
</template>

<script>
export default {
  name: 'attribute-field-STRING',
  props: {
    attributeData: {
      type: Object,
      default: () => {}
    },
    errorMessage: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
